import { Sparkles, ExternalLink, Lock } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useTranslation } from 'react-i18next'

const CALENDLY_URL = 'https://calendly.com/sovereignintelligence/30min'

export function AccessGateOverlay() {
  const { t } = useTranslation()
  const features = [
    t('proprietarySignals'),
    t('aiAssistantFeature'),
    t('realtimeIntelligence'),
  ]

  return (
    <div className="fixed inset-0 z-30 bg-black/70 backdrop-blur-sm flex items-center justify-center p-6">
      <div className="max-w-md w-full">
        {/* Card */}
        <div className="bg-neutral-950/95 border border-white/[0.08] rounded-3xl p-8 shadow-2xl shadow-black/50 space-y-6 text-center">
          {/* Logo */}
          <div className="flex justify-center">
            <div className="w-16 h-16 bg-gradient-to-br from-emerald-500 to-cyan-500 rounded-2xl flex items-center justify-center shadow-lg shadow-emerald-500/30">
              <span
                className="text-black text-4xl"
                style={{
                  fontFamily: "'garamond-atf-text', 'EB Garamond', serif",
                  fontStyle: 'italic',
                  WebkitTextStroke: '1px black',
                }}
              >
                S
              </span>
            </div>
          </div>

          {/* Headline */}
          <div className="space-y-2">
            <h2
              className="text-2xl font-bold text-white"
              style={{
                fontFamily: "'garamond-atf-text', 'EB Garamond', serif",
              }}
            >
              {t('welcomeToSovereign')}
            </h2>
            <p className="text-neutral-400 text-sm leading-relaxed">
              {t('accessGateDescription')}
            </p>
          </div>

          {/* Feature highlights */}
          <div className="space-y-3 text-left">
            {features.map((feature, i) => (
              <div key={i} className="flex items-start gap-3">
                <Sparkles className="w-4 h-4 text-emerald-400 mt-0.5 flex-shrink-0" />
                <p className="text-neutral-300 text-sm">{feature}</p>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="space-y-3 pt-2">
            <a
              href={CALENDLY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="block"
            >
              <Button className="w-full h-12 bg-gradient-to-r from-emerald-500 to-cyan-500 hover:from-emerald-600 hover:to-cyan-600 text-black font-semibold text-base shadow-lg shadow-emerald-500/25 transition-all hover:scale-[1.02] active:scale-[0.98]">
                {t('scheduleIntroCall')}
                <ExternalLink className="w-4 h-4 ml-2" />
              </Button>
            </a>
            <p className="text-neutral-500 text-xs">
              {t('alreadyHaveAccess')}
            </p>
          </div>

          {/* Lock badge */}
          <div className="flex items-center justify-center gap-2 pt-1">
            <Lock className="w-3.5 h-3.5 text-neutral-600" />
            <span className="text-neutral-600 text-xs font-medium">
              {t('inviteOnlyAccess')}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
